/** Детерминированный ГПСЧ (mulberry32). Seed пишется в лог сессии — прогон воспроизводим. */
export class Rng {
  private s: number;

  constructor(public readonly seed: number) {
    this.s = seed >>> 0;
  }

  next(): number {
    this.s = (this.s + 0x6d2b79f5) >>> 0;
    let t = this.s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  /** Равномерно в [-a, a] */
  sym(a: number): number {
    return (this.next() * 2 - 1) * a;
  }

  range(a: number, b: number): number {
    return a + this.next() * (b - a);
  }

  /** true с вероятностью p (0..1) */
  chance(p: number): boolean {
    return this.next() < p;
  }
}
